import React from 'react';
import Conditional from '../../common/conditional';

import { SelectOption } from '../../../utils/models';

import classNames from './style.module.scss';

interface Props {
    item: SelectOption;
	onRemove?: (listItem: SelectOption) => void;
	onEditItem?: (listItem: SelectOption) => void;
}

const ListGroupItem: React.FC<Props> = (props) => {
	return (
		<li className={classNames['list-option-item']}>
            <p>{props.item.name}</p>

            <Conditional isVisible={props.onRemove !== undefined}>
                <button
                    className={classNames['list-option-item-remove']}
                    onClick={() => props?.onRemove?.(props.item)}
                >
                    <i className="bi bi-trash3-fill"></i>
                </button>
            </Conditional>
            
            <Conditional isVisible={props.onEditItem !== undefined}>
                <button
                    className={classNames['list-option-item-edit']}
                    onClick={() => props?.onEditItem?.(props.item)}
                >
                    <i className="bi bi-pencil"></i>
                </button>
            </Conditional>
        </li>
	);
};

export default ListGroupItem;
